import { render, staticRenderFns } from "./ProyectoTitulo.vue?vue&type=template&id=2a7a2adb&scoped=true&"
import script from "./ProyectoTitulo.vue?vue&type=script&lang=js&"
export * from "./ProyectoTitulo.vue?vue&type=script&lang=js&"
import style0 from "./ProyectoTitulo.vue?vue&type=style&index=0&id=2a7a2adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a2adb",
  null
  
)

export default component.exports